export const STATUS = {
    ORDER: {
        newOrderStatus: 1101,
        packingOrderStatus: 1102,
        readyOrderStatus: 1103,
        completedOrderStatus: 1104,
        cancelOrderStatus: 1105,
        readyDeliverOrderStatus: 1106,
        onDeliverOrderStatus: 1107,
        sacondAttemptOrderStatus: 1108,
        tripActivityShipmentOnDelivery: 1109,
        untilDestinationStatus: 1110,
    },
    TRIP: {
        completedTripStatus: 1204,
        deleteTripStatus: 1205,
        readyDeliverTripStatus: 1206,
        onDeliverTripStatus: 1207,
        pendinTripStatus: 1208
    },
    HISTORY_TRACK: {
        idleStatus: 201,
        gpsOfStatus: 202,
        gpsOnStatus: 203,
        logoutStatus: 204,
        loginStatus: 205,
        stopStatus: 207,
        backToMoveStatus: 208
    },
    DRIVER: {
        availableDriverStatus: 3001,
        onDeliverDariverStatus: 3002,
        onTransitDriverStatus: 3003,
        headingToStoreStatus: 3004
    },
    REFUND: {
        refundRequest: 1301,
        refundApproved: 1302,
        refundRejected: 1306,
        refundCompleted: 1304
    },
    POD_OUT_OF_COORDINATE: {
        PODOutOfCoordinateRequest: 1401,
        PODOutOfCoordinateApproved: 1402,
        PODOutOfCoordinateRejected: 1403
    }
}

export const LOCAL_STORAGE_KEY = {
    ThreePL: '3pl-timestamp',
    TrackingCrew: 'crew-timestamp'
};

